export default __webpack_public_path__ + "static/media/blank.04ce49fb.png";